import { useReducer, useEffect, useRef } from "react";
import {
    MapContainer,
} from "react-leaflet";
import { reducer, initialState, Context } from '../../store/reducer';
import NormalHeader from '../../components/Header/normal';
import MapController from '../../components/MapController';
import { mapConfig } from '../../config/env';
import {geoJsonAPI, tmptestAPI} from "../../utils/api";
import { kashika7Options } from "../../components/Header/normal/kashika7config";
import MenuSpot from "../../components/Spot/menu/popup94";
import MapUpdate from "../../components/MapUpdate";
import Geocoder from "../../components/Geocoder";
import Popup94 from "../../components/Spot/menu/popup94";
import Geojson101 from "../../components/Spot/menu/Geojson101";

const Layout = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    // リクエスト中のIDを追跡（2重リクエスト防止）
    const fetchingRef = useRef(new Set());

    useEffect(() => {
        kashika7Options.map(menu =>{
            menu.options.map(options => {
                if (options.type == 'marker'){

                    // APIから取得する
                    tmptestAPI.get(options.url)
                    .then(res=>{
                        dispatch({
                            type: 'SET_DATA',
                            category: options.id,
                            payload: res.data
                        });
                    })
                }
            })
        })

        tmptestAPI.get(process.env.REACT_APP_MENU)
        .then(res=>{
            // console.log(res)
            dispatch({
                type: 'SET_MENU',
                payload: res.data
          });
        })
        
        // ロード完了後にチェック状態にしてマーカーを表示する。
        if (state["vis_94"]) {
            dispatch({
                type: 'TOGGLE_CHECKED',
                category: "vis_94"
            })
        }

    }, [])
    
    return (
        <Context.Provider value={{ state, dispatch }}>
            <NormalHeader />
            <main className="main">
                <div className="main-inner">
                    <MapContainer
                        tap={false}
                        id="map"
                        {...mapConfig}
                    >
                        <Geocoder/>
                        <MapUpdate />
                        <MapController />

                        {kashika7Options.map(menu => {
                            return menu.options.map(options => {

                                if(options.type === 'marker' && state[options.id].checked && state[options.id].data.spots){

                                    if (options.id === 'vis_94') {
                                        return state[options.id].data.spots.map((d, index) =>
                                          <Popup94
                                            key={index.toString()}
                                            option={options}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                          />
                                        )

                                    }
                                    
                                } else if (options.type === 'geojson' && state[options.id].checked) {

                                    // 初回時にのみ値を保持する（2重リクエスト防止にuseRefを使用）
                                    if (state[options.id].data.length === 0 && !fetchingRef.current.has(options.id)) {
                                        // リクエスト中としてマーク
                                        fetchingRef.current.add(options.id);

                                        geoJsonAPI.get(options.url)
                                            .then(res =>{
                                                dispatch({
                                                    type: 'SET_DATA',
                                                    category: options.id,
                                                    payload: res.data
                                                });
                                                // リクエスト完了後にマークを削除
                                                fetchingRef.current.delete(options.id);
                                            })

                                        // 同期が必要なため初回時はnullを返す
                                        return null;
                                    }

                                    // データがまだない場合は描画しない
                                    if (state[options.id].data.length === 0) {
                                        return null;
                                    }

                                    return <Geojson101
                                        key={options.id}
                                        option={options}
                                        data={state[options.id].data}
                                    />

                                }
                            })
                        })}
                        
                    </MapContainer>

                </div>
            </main>
        </Context.Provider>
    )
}

export default Layout;
